import { EXPENSE_MANAGEMENT_ROUTE_NAMES } from '@/shared/common/constants/expenseManagementRoutes.constant';
import type { ExpenseAdministratorSection } from '../types/expenseManagement.type';

export const EXPENSE_MANAGEMENT_TEXTS = {
  ADMINISTRATOR_TITLE: 'Administrador',
  SUBMITTER_TITLE: 'Rendidor',
  APPROVER_TITLE: 'Aprobador',
} as const;

export const EXPENSE_ADMINISTRATOR_SECTIONS: Array<ExpenseAdministratorSection> = [
  {
    key: 'policies',
    label: 'Políticas',
    routeName: EXPENSE_MANAGEMENT_ROUTE_NAMES.POLICIES,
  },
  { key: 'review-flows', label: 'Flujos de revisión', routeName: null },
  { key: 'submitters', label: 'Rendidores', routeName: null },
];
